import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetUsersParams, GetUsersRes } from "api/api/usersApi/types";
import { UsersAPI } from "api/api/usersApi/usersApi";
import axios from "axios";

export const getUsersByAdmins = createAsyncThunk<GetUsersRes, GetUsersParams>(
  "users/getUsersByAdmins",
  async (params, { rejectWithValue }) => {
    try {
      const response = await UsersAPI.getUsersByAdmins(params);
      return response.data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while getting users details by admins", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      else {
        console.error("Error while getting users details by admins", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);